import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { GridLine } from '../../../core/components/grid/GridLine.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';

export const HistogramGridZeroLine = () => {
  const [leftScale] = useHistogramYScales();

  const { width, height } = useGridPlotSize();
  const zeroLineValue = leftScale(0);

  const showLine = zeroLineValue < height;
  const from = { x: 0, y: zeroLineValue };
  const to = {
    x: width,
    y: zeroLineValue,
  };

  return showLine ? (
    <svg className={plotLayout} data-testid="histogram-grid-zero-line-layout">
      <GridLine from={from} to={to} highlight />
    </svg>
  ) : null;
};

HistogramGridZeroLine['displayName'] = 'HistogramGridZeroLine';
